import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CategorizationChangeEvent } from '../../events/categorization-change-event';
import { ListSearchService, ListItemModel, TaxonomyFieldDefinitionService } from 'e5core-angular-services';
import { TaxonomyCategory2Service } from 'e5core-angular-services';
import { UiStyleService } from '../../services/ui-style.service';
import { CategorizationPopulationMode } from "../../enums/categorization-population-mode";

@Component({
    selector: 'e5core-ui-categorization',
    template: `
  <span [ngSwitch]="style.current()">
    <e5core-ui-categorization-box *ngSwitchCase='0' ></e5core-ui-categorization-box>
    <e5core-ui-categorization-bootstrap *ngSwitchCase='1' ></e5core-ui-categorization-bootstrap>
	<e5core-ui-categorization-material *ngSwitchCase='2'
		[hideToLevel]='hideToLevel'
		[categorization]='cat123'
		[labels]='catLabels'
		[readonly]='readonly'
		[cat1List]='cat1List' [cat2List]='cat2List' [cat3List]='cat3List'
		(catChange)='onCategoryChange($event)'></e5core-ui-categorization-material>
  </span>`
})
export class E5coreUiCategorizationComponent implements OnInit {

    readonly CATEGORY1_ID = 'Category1_Id';
    readonly CATEGORY2_ID = 'Category2_Id';
    readonly CATEGORY3_ID = 'Category3_Id';

    @Input() hideToLevel: number;
    @Input() labels: string[];
    @Input() readonly: boolean;
    @Input() populationMode = CategorizationPopulationMode.Default;
    @Output() categorizationChange = new EventEmitter<CategorizationChangeEvent>();
    @Output() defaultComplete = new EventEmitter<CategorizationChangeEvent>();
    @Input() set categorization(cat123: number[]) {
        this.SetCategorisationLists(cat123);
    }
    // Child inputs
    cat1List: ListItemModel[] = [];
    cat2List: ListItemModel[] = [];
    cat3List: ListItemModel[] = [];
    cat123: number[] = [0, 0, 0];
    catLabels: string[] = ['Business Area.', 'Product.', 'Category.'];

    // Locals
    lastCat123: number[] = [0, 0, 0];

    constructor(public style: UiStyleService, private listService: ListSearchService,
        private fieldDefinitonServices: TaxonomyFieldDefinitionService,
        private category2Service: TaxonomyCategory2Service) { }

    ngOnInit() {
        this.InitialiseCategorisationLists(this.cat123);
        this.applyLabels();
    }

    applyLabels() {
        if (this.labels && this.labels[0]) {
            this.catLabels[0] = this.labels[0];
        } else {
            this.fieldDefinitonServices.get('Category1_Id').subscribe(fd => this.catLabels[0] = fd.label);
        }

        if (this.labels && this.labels[1]) {
            this.catLabels[1] = this.labels[1];
        } else {
            this.fieldDefinitonServices.get('Category2_Id').subscribe(fd => this.catLabels[1] = fd.label);
        }

        if (this.labels && this.labels[2]) {
            this.catLabels[2] = this.labels[2];
        } else {
            this.fieldDefinitonServices.get('Category3_Id').subscribe(fd => this.catLabels[2] = fd.label);
        }
    }

    onCategoryChange($event: CategorizationChangeEvent) {
        if (this.cat123[0] !== this.lastCat123[0]) {
            // Load new Cat 2, reset cat 3
            this.listService.search(this.CATEGORY2_ID, { parentListItemId: this.cat123[0] }).subscribe(
                cat2List => {
                    this.cat2List = cat2List;
                }

            );

            this.lastCat123 = [this.cat123[0], undefined, undefined];
            this.cat123[1] = this.cat123[2] = undefined;
            this.cat2List = this.cat3List = [];
            $event.category2Id = $event.category3Id = 0;
        }
        if (this.cat123[1] !== this.lastCat123[1]) {
            // Load new Cat 3
            this.listService.search(this.CATEGORY3_ID, { parentListItemId: this.cat123[1] }).subscribe(
                cat3List => {
                    this.cat3List = cat3List;
                }
            );
            this.lastCat123 = [this.cat123[0], this.cat123[1], undefined];
            this.cat123[2] = undefined;
            this.cat3List = [];
        }

        this.EmitCategorizationChangeEvent($event);
    }

    private loadCategorization1(cat123: number[]) {
        this.lastCat123 = [...cat123];
        if (cat123 && cat123.length >= 1 && +(cat123[0]) !== 0) {
            // Load the Category 1 and select it
            this.listService.search(this.CATEGORY1_ID, {}).subscribe(
                catList => {
                    const cat = catList.find(c => +c.id === cat123[0]);
                    if (cat) {
                        this.cat1List = catList;
                        this.cat123 = [cat123[0], 0, 0];
                        this.loadCategorization2(cat123, cat123[0]);
                    } else {
                        this.cat1List = this.cat2List = this.cat3List = [];
                        this.cat123 = [0, 0, 0];
                    }
                }
            );
        }
    }

    private loadCategorization2(cat123: number[], parentId: number) {
        if (cat123 && cat123.length >= 2 && +(cat123[1]) !== 0) {
            // Load the Category 2 and select it
            this.listService.search(this.CATEGORY2_ID, { parentListItemId: parentId }).subscribe(
                catList => {
                    const cat = catList.find(c => +c.id === cat123[1]);
                    this.cat2List = catList;
                    if (cat) {
                        this.cat123 = [cat123[0], cat123[1], 0];
                        this.loadCategorization3(cat123, cat123[1]);
                    } else {
                        this.cat3List = [];
                        this.cat123 = [cat123[0], 0, 0];
                    }
                }
            );
        }
    }

    private loadCategorization3(cat123: number[], parentId: number) {
        if (cat123 && cat123.length >= 3 && +(cat123[2]) !== 0) {
            // Load the Category 3 and select it
            this.listService.search(this.CATEGORY3_ID, { parentListItemId: parentId }).subscribe(
                catList => {
                    const cat = catList.find(c => +c.id === cat123[2]);
                    this.cat3List = catList;
                    if (cat) {
                        this.cat123 = [cat123[0], cat123[1], cat123[2]];
                    } else {
                        this.cat123 = [cat123[0], cat123[1], 0];
                    }
                }
            );
        }
    }

    private getCategory1(cat123: number[], event: CategorizationChangeEvent) {
        // Get the Category1 Id using the Category2
        this.category2Service.get(cat123[1], 0).subscribe(
            cat => {
                if (cat) {
                    this.cat123 = [cat.category1Id, cat123[1], cat123[2]];
                } else {
                    this.cat123 = [cat123[0], cat123[1], cat123[2]];
                }
                this.lastCat123 = [...this.cat123];
                event.category1Id = cat.category1Id;
                this.categorizationChange.emit(event);
            }
        );
    }

    private InitialiseCategorisationLists(cat123: number[]) {
        switch (this.populationMode) {
            case CategorizationPopulationMode.PopulateAllLevel2:
                this.hideToLevel = 1;
                this.cat123[0] = 0;
                this.lastCat123 = [...cat123];
                this.listService.search(this.CATEGORY2_ID).subscribe(
                    list => {
                        this.cat2List = list;
                    }
                );
                break;
            case CategorizationPopulationMode.Default:
                this.listService.search(this.CATEGORY1_ID).subscribe(
                    list => {
                        this.cat1List = list;
                    }
                );
                break;
        }
    }

    private SetCategorisationLists(cat123: number[]) {
        switch (this.populationMode) {
            case CategorizationPopulationMode.PopulateAllLevel2:
                this.loadCategorization2(cat123, 0);
                break;
            case CategorizationPopulationMode.Default:
                this.loadCategorization1(cat123);
                break;
        }
    }

    private EmitCategorizationChangeEvent(event: CategorizationChangeEvent) {
        switch (this.populationMode) {
            case CategorizationPopulationMode.PopulateAllLevel2:
                if (this.cat123[2] !== this.lastCat123[2]) {
                    this.getCategory1(this.cat123, event);
                }
                break;
            case CategorizationPopulationMode.Default:
                if (this.cat123[2] !== this.lastCat123[2] && this.cat123[2] !== 0) {
                    this.categorizationChange.emit(event);
                }
                break;
        }

    }

}
